export const unreachableFallback = <T>(_value: never, fallback: T): T =>
  fallback;
